import { useCallback } from "react";
import useLatestValue from "./useLatestValue";

/*
  useEffectEvent: would be helpful to have access to latest stable callback
  in useEffect, which is always closed over latest state, rather than the stale state.
  React team are working on providing this in React itself, once available we can use that
  Refer: https://react.dev/reference/react/experimental_useEffectEvent
         https://github.com/reactjs/rfcs/blob/useevent/text/0000-useevent.md
*/
const useEffectEvent = fn => {
  const latestFunc = useLatestValue(fn);
  return useCallback((...args) => latestFunc.current(...args), [latestFunc]);
};

export default useEffectEvent;
